<template>
    <div class="container-fluid d-flex align-items-center justify-content-center vh-100">
      <div class="w-100">
      <div class="row justify-content-center">
            <div class="col-3 my-3 text-center">
                <img width="300" src="../assets/health-here-logo.svg"/>
            </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-3">
            <div class="alert alert-info" role="alert" v-show="message">
                <div>{{ message }}</div>
            </div>
            <div class="alert alert-danger" role="alert" v-show="errors.length > 0">
                <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
            </div>
          <div v-if="$route.query.reason === 'mfaExpired'" class="alert alert-danger">
            Your session expired during two-factor setup. Please log in and try again.
          </div>
          </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <form class="form-horizontal">
                    <div class="form-group">
                        <label for="inputEmail3" class="control-label">Email</label>
                        <div class="">
                            <input type="email" v-model="credentials.email" class="form-control" id="inputEmail3"
                                   placeholder="Email">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputPassword3" class="control-label">Password</label>
                        <div class="">
                            <input type="password" v-model="credentials.password" class="form-control"
                                   id="inputPassword3" placeholder="Password">
                          <a class="forgotPasswordLink" href="#" @click.prevent="showForgotPassword()">Forget your password?</a>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="">
                            <button type="submit" @click.prevent="submit()" class="btn btn-orange btn-block">Sign in
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
  import api from '../services/api'

  export default {
    name: 'login',

    props: {
      nextPath: {
        type: String,
        default: '/'
      }
    },

    data () {
      return {
        showLogin: false,
        credentials: {
          email: '',
          password: ''
        },
        data: {
          requiresTwoFactor: false,
          pendingToken: '',
          requiresTotpSetup: false
        },
        errors: [],
        message: this.$route.query.message
      }
    },

    methods: {
      submit () {
        this.errors = []
        this.message = ''
        const credentials = {
          email: this.credentials.email,
          password: this.credentials.password
        }

        api.post('/Auth/Login', credentials).then(response => {
          const data = response.data
          if (data.requiresTwoFactor) {
            this.$router.push({
              path: '/two-factor',
              query: { token: data.pendingToken }
            })
            return
          }
          if (data.requiresTotpSetup) {
            this.$router.push({
              path: '/two-factor-setup',
              query: { token: data.pendingToken }
            })
            return
          }
          if (!data.organizationId) {
            this.errors = ['This user is not configured for an organization']
          } else {
            const userRoles = data.roles.filter(role => role === 'Admin' || role === 'OrganizationUser' || role === 'OrganizationAdmin' || role === 'OrganizationPayee' || role === 'OrganizationEmployerUser')

            if (userRoles && userRoles.length > 0) {
              this.$store.userAuthenticated(data, null, () => {
                let path = this.nextPath
                if (path === '/logout') {
                  path = '/'
                }
                if (path === '/') {
                  path = this.$store.homePagePath
                }
                this.$router.push(path)
              })
            } else {
              this.errors = ['This user does not have the appropriate roles to access the dashboard']
            }
          }
        }, errorResponse => {
          if (errorResponse.response) {
            this.errors = errorResponse.response.data.login_failure
          } else {
            this.errors = [errorResponse.message]
          }
          this.$store.logoutUser()
        })

      },

      showForgotPassword () {
        this.$router.push({ path: 'forgot-password', query: { email: this.credentials.email } })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.forgotPasswordLink {
  display: flex;
  justify-content: flex-end;
}
</style>
